/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartModification } from './CartModification';
import {
    CartModificationFromJSON,
    CartModificationFromJSONTyped,
    CartModificationToJSON,
} from './CartModification';

/**
 * Representation of a Cart modification list
 * @export
 * @interface CartModificationList
 */
export interface CartModificationList {
    /**
     * List of cart modifications
     * @type {Array<CartModification>}
     * @memberof CartModificationList
     */
    cartModifications?: Array<CartModification>;
}

/**
 * Check if a given object implements the CartModificationList interface.
 */
export function instanceOfCartModificationList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CartModificationListFromJSON(json: any): CartModificationList {
    return CartModificationListFromJSONTyped(json, false);
}

export function CartModificationListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CartModificationList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cartModifications': !exists(json, 'cartModifications') ? undefined : ((json['cartModifications'] as Array<any>).map(CartModificationFromJSON)),
    };
}

export function CartModificationListToJSON(value?: CartModificationList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cartModifications': value.cartModifications === undefined ? undefined : ((value.cartModifications as Array<any>).map(CartModificationToJSON)),
    };
}

